module.exports = __webpack_public_path__ + "static/img/banner-200120-cny.e9fab92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-200120-cny.png
// module id = qUYT
// module chunks = 1